export default __webpack_public_path__ + "static/media/i159vp.4d1893ec.webp";